import { Component, OnInit } from '@angular/core';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { ExportacaoAgenteFinanceiroService } from './exportacao-agente-financeiro.service';
import { ExportacaoGestorService } from './exportacao-gestor.service';
import { DatePipe } from '@angular/common';
import { DataSistemaService } from 'src/app/shared/services/data-sistema.service';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import moment from "moment";

@Component({
    selector: 'app-solicitacoes-honras-exportacao',
    templateUrl: './solicitacoes-honra-exportacao.component.html',
    styleUrls: ['./solicitacoes-honra-exportacao.component.scss'],
    standalone: false
})
export class SolicitacoesHonraExportacaoComponent implements OnInit {

    private exportacaoGestor: boolean;
    private janela: Date;
    private dataAtual: Date;

    constructor(private fileUtils: FileUtilsService,
        private permissaoService: PermissaoService,
        private agenteService: ExportacaoAgenteFinanceiroService,
        private gestorService: ExportacaoGestorService,
        private datePipe: DatePipe,
        private alertService: BnAlertsService,
        private dataSistemaService: DataSistemaService) {
    }

    ngOnInit(): void {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            if (resp && resp[ROLE_GESTOR_CONSULTA]) {
                this.exportacaoGestor = true;
            }
        });

        this.dataSistemaService.getDataCorrenteStr().subscribe(
            dataCorrente => this.dataAtual = dataCorrente);
    }

    exportarHonras() {
        const params: any = {};
        const dataJanela : Date = this.janela;
        if (dataJanela) {
            params.nomeJanela = this.datePipe.transform(dataJanela, 'MM/yyyy');
        }

        if(this.verificaDataEnvio(dataJanela)) {
            if (this.exportacaoGestor) {
                this.gestorService.getHonras(params).subscribe((conteudoArquivo) => {
                    this.fileUtils.exportarArquivoUTF8('SolicitacoesHonra.csv',
                        conteudoArquivo, FileUtilsService.TEXT_CSV);
                });
            } else {
                this.agenteService.getHonras(params).subscribe((conteudoArquivo) => {
                    this.fileUtils.exportarArquivoUTF8('SolicitacoesHonra.csv',
                        conteudoArquivo, FileUtilsService.TEXT_CSV);
                });
            }
        }
    }

    private verificaDataEnvio(dataJanela: Date) {
        const dataJanelaEndMonth = moment(dataJanela).endOf('month');
        let dataAtualComparativo18Meses = moment().subtract(18, 'months').endOf('month');
        if(dataJanelaEndMonth.isBefore(dataAtualComparativo18Meses)) {
            this.exibirErro();
            return false;
        }
        return true;
    }

    public limpar() {
        this.janela = null;
    }

    exibirErro() {
        this.alertService.alertaErro('Erro', 'Janela selecionada deverá ser no máximo dos últimos 18 meses.');
    }

}